import {useNavigate} from "react-router-dom";

export const useRedirect = () => {
    const navigate = useNavigate()

    return () => {
        const url = new URL(window.location.href);
        if (!url.searchParams.has('redirectTo')) {
            return false;
        }

        const redirectTo = decodeURI(url.searchParams.get('redirectTo') || '');
        navigate(redirectTo);
        return true;
    }
}
